
import { useEffect, useState } from "react";
import { FaGithub, FaLinkedin, FaGlobe } from "react-icons/fa";
import Header from "./components/Header";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

function App() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      const total = scrollHeight - clientHeight || 1;
      setScrollProgress((scrollTop / total) * 100);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="app">
      {isLoading && (
        <div className="app-loader">
          <div className="app-loader-logo">TJ</div>
          <div className="app-loader-text">Preparing your portfolio…</div>
          <div className="app-loader-bar">
            <div className="app-loader-bar-inner" />
          </div>
        </div>
      )}

      <div className="scroll-progress">
        <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }} />
      </div>

      <main className="app-inner">
        <Header />
        <section id="about" className="section">
          <About />
        </section>
        <section id="skills" className="section">
          <Skills />
        </section>
        <section id="experience" className="section">
          <Experience />
        </section>
        <section id="projects" className="section">
          <Projects />
        </section>
        <section id="contact" className="section">
          <Contact />
        </section>

        <footer className="footer">
          <div className="footer-inner">
            <span>© {new Date().getFullYear()} Tahir Jamal. All rights reserved.</span>
            <div className="footer-social">
              <a
                href="https://github.com"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                <FaGithub /> GitHub
              </a>
              <a
                href="https://tahirjamal.com"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                <FaGlobe /> Portfolio
              </a>
              <a
                href="https://linkedin.com/in/tahir-jamal-cyb16/"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                <FaLinkedin /> LinkedIn
              </a>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
